

import LecomRefluxActions from './lecom_reflux_actions';
import LecomRefluxStore from './lecom_reflux_store';

export const createActions = (actions = []) => {
	return Reflux.createActions(LecomRefluxActions.concat(actions));
};

export const createStore = (store = {}) => {
	return Reflux.createStore(Object.assign({}, $.extend(true, {}, LecomRefluxStore), store));
};

export default {
	createActions,
	createStore,
};
